import request from '@/utils/request'

let Recomm_award_logApi = {

  /*推荐奖触发记录列表*/
  list(data) {
    return request._post('/shop/plus.recomm_award_log.Index/index', data);
},
/*添加推荐奖触发记录*/
add(data) {
    return request._post('/shop/plus.recomm_award_log.Index/add', data);
},
/*修改推荐奖触发记录*/
edit(data) {
    return request._post('/shop/plus.recomm_award_log.Index/edit', data);
},
/*删除推荐奖触发记录*/
del(data) {
    return request._post('/shop/plus.recomm_award_log.Index/del', data);
},
/*推荐奖触发记录详情*/
detail(data) {
  return request._post('/shop/plus.recomm_award_log.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.recomm_award_log.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.recomm_award_log.Setting/getSetting', data, errorback);
    },
}
export default Recomm_award_logApi;



// WEBPACK FOOTER //
// ./src/api/recomm_award_log.js